<template>
  <div>
    <BaseModal
      overflowable
      :showing="visible"
      @close="onClose"
      :showClose="visible"
      :backgroundClose="true"
      size="max-w-5xl"
    >
      <div class="flex items-center justify-between">
        <div>
          <h3 class="text-lg font-bold leading-6 text-gray-900">
            {{ title }}
          </h3>
          <p class="mt-1 max-w-2xl text-sm text-gray-500">
            {{ description }}
          </p>
        </div>
        <div>
          <img src="@/assets/images/logo.png" alt="" class="w-32" />
        </div>
      </div>

      <div class="relative">
        <base-input
          type="text"
          label="Kode Kantor"
          id="code"
          placeholder="Masukkan kode kantor"
          inset
          with-label
          fullwidth
          @blur="handleBlurOffice"
          v-model="selectedOffice.attributes.code"
        />
        <button
          type="button"
          class="absolute inset-y-0 top-4 right-4 flex cursor-pointer items-center pl-3"
          @click="toggleOfficeModal"
        >
          <Icon
            class="h-5 w-5 text-gray-500 hover:text-gray-700"
            icon="heroicons:magnifying-glass-circle-20-solid"
          />
        </button>
      </div>

      <Datatable withOverflow class="mt-8" :paginated="false" :footer="false">
        <template v-slot:thead>
          <thead class="bg-gray-50">
            <tr>
              <th
                v-for="item in [
                  {
                    label: 'Kode',
                  },
                  {
                    label: 'Nama',
                  },
                  {
                    label: 'Status',
                  },
                  {
                    label: 'Jumlah',
                    classes: 'text-right',
                  },
                  {
                    label: 'Aksi',
                    classes: 'text-right',
                  },
                ]"
                scope="col"
                class="whitespace-nowrap px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
                :class="item.classes"
                :key="item.label"
              >
                {{ item.label }}
              </th>
            </tr>
          </thead>
        </template>
        <template v-slot:tbody>
          <tbody>
            <template v-for="(movementDetail, i) in movementDetails">
              <tr :key="i">
                <td class="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
                  <div class="relative" style="width: fit-content">
                    <base-select-search
                      :is-loading="false"
                      :data="getStocks.data ?? []"
                      label="product_code"
                      placeholder="Cari Kode"
                      v-model="movementDetail.product_id"
                      v-on:infinite-scroll="handleInfiniteScroll"
                      v-on:search="handleSearch"
                      v-on:change="handleChange"
                    />
                  </div>
                </td>
                <td
                  :title="movementDetail?.product_id.attributes?.product_name"
                  style="
                    max-width: 200px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  "
                  class="whitespace-nowrap px-6 py-4 text-sm text-gray-500"
                >
                  {{ movementDetail?.product_id.attributes?.product_name }}
                </td>
                <td
                  class="whitespace-nowrap px-6 py-4 text-right text-sm text-gray-500"
                >
                  <base-select
                    :options="[
                      {
                        label: 'Pilih Status',
                        value: null,
                      },
                      {
                        label: 'Layak Dijual',
                        value: 'suitable_for_sale',
                      },
                      {
                        label: 'Tidak Layak Dijual',
                        value: 'unsuitable_for_sale',
                      },
                      {
                        label: 'Expired',
                        value: 'expired',
                      },
                      {
                        label: 'Rusak',
                        value: 'damaged',
                      },
                    ]"
                    v-model="movementDetail.product_status"
                  />
                </td>
                <td
                  class="whitespace-nowrap px-6 py-4 text-right text-sm text-gray-500"
                >
                  <input
                    type="text"
                    name="jumlah_barang"
                    ref="jumlah_barang"
                    placeholder="Jumlah"
                    v-model="movementDetail.product_qty"
                    class="block w-full border-0 p-0 text-right placeholder-gray-200 focus:ring-0 sm:text-sm"
                  />
                </td>
                <td
                  class="whitespace-nowrap px-6 py-4 text-right text-sm text-gray-500"
                >
                  <button type="button" @click="movementDetails.splice(i, 1)">
                    <Icon class="h-4 w-4" icon="heroicons:x-mark-20-solid" />
                  </button>
                </td>
              </tr>
            </template>
          </tbody>
        </template>
      </Datatable>
      <div class="mt-8 flex justify-between">
        <div>
          <base-button
            color="white"
            @click="
              movementDetails.push({
                product_id: {},
                product_qty: 0,
                product_status: null,
              })
            "
            type="button"
          >
            Tambah Produk
          </base-button>
        </div>
        <base-button
          @click="handleSave"
          type="button"
          :disabled="!selectedOffice.id || !selectedWarehouse.id"
        >
          Submit
        </base-button>
      </div>
    </BaseModal>
    <OfficeModal
      :is-visible="visibleOfficeModal"
      @onSearchKantor="searchOffice"
      @onPageChangeKantor="onPageChangeOffice"
      @change-office="changeOffice"
      @closeKantorModal="() => (visibleOfficeModal = !visibleOfficeModal)"
    />
  </div>
</template>
<script>
import BaseInput from '@/components/base/BaseInput.vue';
import BaseModal from '@/components/base/BaseModal.vue';
import Datatable from '@/components/base/Datatable.vue';
import BaseButton from '@/components/base/BaseButton.vue';
import { mapGetters, mapActions } from 'vuex';
import BaseSelectSearch from '@/components/base/BaseSelectSearch.vue';
import BaseSelect from '@/components/base/BaseSelect.vue';
import OfficeModal from '@/components/office/office-modal.vue';
import debounce from 'debounce';

export default {
  name: 'PengeluaranClassificationModal',
  components: {
    BaseModal,
    Datatable,
    BaseButton,
    BaseInput,
    BaseSelect,
    BaseSelectSearch,
    OfficeModal,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Detail Barang',
    },
    description: {
      type: String,
      default: 'Detail Barang',
    },
    perusahaan: Boolean,
  },
  data() {
    return {
      filter: {
        search: null,
      },
      officeFilter: {
        page: {
          size: 5,
          number: 1,
        },
        search: null,
      },
      visibleOfficeModal: false,
      selectedOffice: {
        attributes: {
          code: null,
        },
      },
      selectedWarehouse: {},
      movementDetails: [
        {
          product_id: '',
          product_qty: 0,
          product_status: null,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      getOfficeCategories: 'office_categories/getOfficeCategories',
      getStockMovement: 'stock_movements/getStockMovement',
      getStocks: 'stocks/getStocks',
      me: 'auth/getUser',
    }),
    selectStockOptions() {
      return [
        ...this.getStocks.data.map((stock) => {
          return {
            key: stock.attributes.product_code,
            value: stock.id,
            label: stock.attributes.product_code,
          };
        }),
      ];
    },
    warehouseParams() {
      const params = {};
      if (this.perusahaan) {
        params.notCode = 'pusat';
      }
      return params;
    },
    officeParams() {
      const params = {
        // include: 'addresses,area',
        'page[limit]': this.officeFilter.page.size,
        'filter[search]': this.officeFilter.search,
        'filter[office_category_id]': 4,
        'fields[offices]': 'code,name,phone,email,address,addresses,area',
      };

      // if (this.perusahaan) {
      //   params['filter[stockist_type]'] = 'PRSH';
      // } else {
      //   params.office_type = 'supplier';
      // }

      return params;
    },
  },
  methods: {
    ...mapActions({
      fetchOffices: 'offices/fetchOffices',
      classifyMovementDetail: 'stock_movements/classifyMovementDetail',
      fetchStocksByWarehouse: 'stocks/fetchStocksByWarehouse',
      fetchWarehouseByOffice: 'warehouses/fetchWarehouseByOffice',
    }),
    handleBlurOffice() {
      if (!this.selectedOffice.attributes.code) {
        return;
      }
      this.fetchOffices({
        'filter[search]': this.selectedOffice.attributes.code,
      }).then((response) => {
        this.selectedOffice = response.data.data[0];
        this.fetchWarehouseByOffice({
          userOfficeId: this.selectedOffice.id,
          ...this.warehouseParams,
        }).then((response) => {
          this.selectedWarehouse = response.data.data[0];
        });
      });
    },
    searchOffice: debounce(function (code) {
      this.fetchOffices({
        ...this.officeParams,
        'filter[search]': code,
      });
    }, 300),
    handleSearch(value) {
      console.log({ value });
    },
    changeOffice(office) {
      this.selectedOffice = office;
      this.visibleOfficeModal = !this.visibleOfficeModal;
      this.fetchWarehouseByOffice({
        userOfficeId: office.id,
        ...this.warehouseParams,
      }).then((response) => {
        this.selectedWarehouse = response.data.data[0];
      });
    },
    handleChange() {},
    handleChangeProduct() {},
    handleInfiniteScroll() {},
    toggleOfficeModal() {
      this.visibleOfficeModal = !this.visibleOfficeModal;
      this.fetchOffices(this.officeParams);
    },
    onPageChangeOffice(page) {
      this.officeFilter.page.number = page;
      this.fetchOffices(this.officeParams);
    },
    async handleSave() {
      const payload = {
        data: {
          type: 'stock-movements',
          attributes: {
            origin_office_id: this.me.office_id,
            destination_office_id: this.selectedOffice.id,
            origin_warehouse_id: this.me.current_warehouse,
            destination_warehouse_id: this.selectedWarehouse.id,
            movement_details: this.movementDetails.map((detail) => {
              return {
                product_id: detail.product_id.relationships.product.data.id,
                product_qty: parseInt(detail.product_qty),
                product_status: detail.product_status,
              };
            }),
          },
        },
      };
      await this.classifyMovementDetail({
        payload,
      });
      this.movementDetails = [
        {
          product_id: '',
          product_qty: 0,
          product_status: null,
        },
      ];
      this.$emit('refetch');
      this.onClose({ allModal: true });
    },
    onClose(value) {
      this.$emit('close', value);
    },
    stockParams({ warehouseId } = {}) {
      return {
        'filter[search]': this.filter.search,
        warehouse_id: warehouseId ?? this.me.current_warehouse,
        pageNumber: 1,
        pageSize: 5,
        include: 'product',
      };
    },
  },
  created() {
    this.fetchStocksByWarehouse(this.stockParams());
  },
};
</script>
